// extracted by mini-css-extract-plugin
export default {"root":"NextWeather_root__JPAG9","section":"NextWeather_section__W0aIZ","list":"NextWeather_list__Kp8Le","date":"NextWeather_date__a09wM","temp":"NextWeather_temp__VXPlO"};